import React from 'react';
import { Divider, Loader } from 'rsuite';
import { DoubleTickIcon } from '../../svg/iconDashSvg';


const PayInstIntro = ({onForward, loading}) => {

    const introText = [
        <span>Попълваш само <b>номер на МПС  и номер на съществуваща  полица</b></span>,
        <span>Създаваш профил, за да виждаш полицата впоследствие</span>,
        <span>Плащаш с карта <b>бързо и сигурно</b></span>,
        <span>Ще получиш <b>напомняне при изтичане</b> на полицата и/или при плащане на вноска </span>,
    ]

    const rendeIntroText = () => {
        return introText.map((text, i) => {
            return <div key={i+1} style={{display: 'flex', gap: '0.5rem', margin: '.5rem 2rem ', alignItems: 'center'}}>
                        <DoubleTickIcon />
                        <p>{text}</p>
                    </div>
        })
    }

    return (
        <div className="steps_container" >
            <h6 className="header-main">ГРАЖДАНСКА ОТГОВОРНОСТ</h6>
            <Divider />
            <div style={{textAlign: 'center', margin: '18px 0 38px 0'}}>
                <img src="/img/logo-dark.png" alt="Nu INS logo" style={{width:"100px"}}></img>
            </div>
        
            <p style={{padding:"0 2rem", marginBottom: '40px', textAlign:"center",fontSize:"1.1rem"}}>Плащане на <b>вноска по полица,</b> която е или не е сключена чрез Nu INS</p>
           
            {rendeIntroText()}

            <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" onClick={()=>onForward(2)}>Започни</button>
        </div>   
    )
}

export default PayInstIntro;

